import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TConfiguredServicesDataTableData = {
  fdk: string,
  offeredServices: string,
  transactionType: string,
  p1: string,
  p2: string,
  p3: string,
  p4: string,
  p5: string,
  p6: string,
  p7: string,
  p8: string,
  [x: string]: string | number | boolean,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TConfiguredServicesDataTableData>();

export function getConfiguredServicesDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('fdk', {
      id: 'fdk',
      header: 'Fdk',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),
    columnHelper.accessor('offeredServices', {
      id: 'offeredServices',
      header: 'Offered Services',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('transactionType', {
      id: 'transactionType',
      header: 'Transaction Type',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.group({
      header: 'Operation Buffer',
      columns: [
        columnHelper.accessor('p1', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P1'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p2', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P2'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p3', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P3'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p4', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P4'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p5', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P5'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p6', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P6'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p7', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P7'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
        columnHelper.accessor('p8', {
          header: '',
          footer: () => {
            return (
              <Center>
                <Skeleton isLoaded={!isLoading}>{'P8'}</Skeleton>
              </Center>
            );
          },
          cell: (props) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
              </Skeleton>
            );
          },
        }),
      ],
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
